// extracted by mini-css-extract-plugin
export default {"__smart-grid-layout-items-gap":"12px","smartGridLayoutItemsGap":"12px"};